export default __webpack_public_path__ + "static/media/loading-loading-forever.1952935e.gif";